'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = undefined;

var _palette = require('./palette');

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = exports.defaultTheme = {
  paddingBase: 1,
  marginBase: 1,
  borderBase: 1,
  fontBase: 1,
  borderRadiusBase: 4.5,
  animationDurationBase: 0,
  boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.17)',
  colors: {
    primary: _palette2.default.black,
    primaryInverse: _palette2.default.white,
    primaryLight: _palette2.default.grey,
    primaryVeryLight: _palette2.default.lightGrey,
    secondary: _palette2.default.white,
    secondaryInverse: _palette2.default.black,
    tertiary: _palette2.default.lightGrey,
    tertiaryInverse: _palette2.default.white,
    disabled: _palette2.default.lightGrey,
    success: _palette2.default.green,
    successInverse: _palette2.default.green,
    confirmation: _palette2.default.lightGreen,
    confirmationInverse: _palette2.default.lightGreen,
    error: _palette2.default.red,
    errorInverse: _palette2.default.red
  },
  palette: _palette2.default,
  font: {
    baseFamily: 'HelveticaLightCn',
    baseSize: '12px',
    headerFamily: 'TradeGothicLTStd-BdCn20'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/themes/defaultTheme.js
// module id = 162
// module chunks = 0